export const PLAN_RANK = {
  starter: 0,
  listing_only_private: 1,
  listing_only_agency: 1,
  pro: 2,
  agency: 3
};

// Temporary testing override: unlock all subscription-gated features.
const ALLOW_ALL_FEATURES_FOR_TESTING = false;

function toDate(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  return new Date(value);
}

export function isPaidStatus(status, currentPeriodEnd) {
  if (status === 'active' || status === 'trialing' || status === 'past_due') return true;
  if (status !== 'canceled' || !currentPeriodEnd) return false;
  const endDate = toDate(currentPeriodEnd);
  return endDate && endDate.getTime() > Date.now();
}

export function hasActivePlan(subscription, requiredPlan = 'pro') {
  if (ALLOW_ALL_FEATURES_FOR_TESTING) return true;
  const plan = subscription?.plan || 'starter';
  const status = subscription?.status || 'none';
  const currentPeriodEnd = subscription?.currentPeriodEnd || null;
  if (!isPaidStatus(status, currentPeriodEnd)) return false;
  return PLAN_RANK[plan] >= PLAN_RANK[requiredPlan];
}

export const PLAN_PROPERTY_LIMITS = {
  starter: 1,
  listing_only_private: 9999,
  listing_only_agency: 9999,
  pro: 9999,
  agency: 9999,
};

export function getPropertyLimit(plan) {
  return PLAN_PROPERTY_LIMITS[plan] || 1;
}
